import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { currencyFormatter } from 'core/utils/commonUtils';
import SimplePage from 'layout/pages/SimplePage/SimplePage';
import { useEffect, useState } from 'react';
import { analyticsService } from 'services/analyticsService';
import MetricCard from './components/MetricCard';
import OrdersChart from './components/OrdersChart';
import RevenueChart from './components/RevenueChart';
import { formatNumber } from './utils';
import type { GeneralMetrics } from 'models/analytics/generalMetrics';
import type { FC } from 'react';

const GeneralData: FC<{ data: GeneralMetrics }> = ({ data }) => (
  <Grid container spacing={3} mb={4}>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <MetricCard
        type='orders'
        title='Активные заказы'
        description='Количество заказов в работе из общего числа заказов за все время'
        value={
          <Box display='flex' alignItems='baseline' gap={1}>
            {formatNumber(data.activeOrdersCount)}
            <Typography variant='body2' color='text.secondary'>
              из {formatNumber(data.totalOrdersCount)}
            </Typography>
          </Box>
        }
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <MetricCard
        type='revenue'
        title='Общая выручка'
        description='Сумма всех полученных платежей по заказам'
        value={currencyFormatter.format(data.totalRevenue)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <MetricCard
        type='average'
        title='Средний чек'
        description='Средняя стоимость заказа, рассчитанная на основе всех завершенных заказов'
        value={currencyFormatter.format(data.averageCheck)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <MetricCard
        type='conversion'
        title='Конверсия'
        description='Процент заявок, перешедших в статус заказа'
        value={`${data.conversionRate.toLocaleString(undefined, {
          style: 'percent',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}`}
      />
    </Grid>
  </Grid>
);

const AnalyticsPage: FC = () => {
  const [data, setData] = useState<GeneralMetrics | null>(null);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const generalData = await analyticsService.getAnalytics();
      setData(generalData);
    };
    void fetchData();
  }, []);

  return (
    <SimplePage title='Аналитика'>
      {data && <GeneralData data={data} />}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <OrdersChart />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <RevenueChart />
        </Grid>
      </Grid>
    </SimplePage>
  );
};

export default AnalyticsPage;
